module.exports = __webpack_public_path__ + "img/LandCoverComparison_IGBP-LC_2.da53d679.jpg";